(() => {
  "use strict";

  // Only run on product pages that have the XO product wrapper
  const productRoot = document.querySelector("xo-product[xo-product-information]");
  if (!productRoot) return;

  const sectionId = productRoot.getAttribute("xo-section-id");
  const productId = productRoot.getAttribute("xo-product-id");

  if (!sectionId || !productId) return;

  const PRICE_UID = `product-price-${productId}`;

  const log = (...args) => {
    // Keep quiet in production; uncomment for debugging
    // console.log("[variant-price-sync]", ...args);
  };

  const getVariantId = () => {
    const sp = new URLSearchParams(window.location.search);
    const v = sp.get("variant");
    if (v) return v;

    // Fallback: look for product form hidden id input
    const form = productRoot.querySelector('form[action^="/cart/add"]');
    const idInput = form?.querySelector('input[name="id"]');
    return idInput?.value || null;
  };

  let lastVariantId = null;
  let inflight = null;
  let debounceId = null;

  const replacePriceNodes = (nextDoc) => {
    const next = nextDoc.querySelector(`xo-product-will-change[xo-unique-id="${PRICE_UID}"]`);
    if (!next) {
      log("No next price node found in fetched HTML");
      return false;
    }

    const currentNodes = document.querySelectorAll(`xo-product-will-change[xo-unique-id="${PRICE_UID}"]`);
    if (!currentNodes.length) {
      log("No current price nodes found on page");
      return false;
    }

    currentNodes.forEach((node) => {
      // Replace the whole node so badge/compare-at etc update too
      node.outerHTML = next.outerHTML;
    });

    return true;
  };

  const fetchSectionHtml = async (variantId) => {
    // Use Shopify Section Rendering API
    const url = new URL(window.location.origin + window.location.pathname);
    url.searchParams.set("variant", variantId);
    url.searchParams.set("section_id", sectionId);

    const res = await fetch(url.toString(), {
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    if (!res.ok) throw new Error(`Section fetch failed (${res.status})`);
    return await res.text();
  };

  const syncPrice = async (variantId) => {
    if (!variantId) return;
    if (variantId === lastVariantId) return;

    lastVariantId = variantId;

    // Cancel any inflight request by ignoring its result
    const token = {};
    inflight = token;

    try {
      const html = await fetchSectionHtml(variantId);
      if (inflight !== token) return; // superseded

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const ok = replacePriceNodes(doc);
      if (!ok) {
        // If the theme structure differs, at least try a fallback selector:
        const nextPriceWrap = doc.querySelector(".xo-product-info-content__price");
        const curPriceWrap = document.querySelector(".xo-product-info-content__price");
        if (nextPriceWrap && curPriceWrap) {
          curPriceWrap.innerHTML = nextPriceWrap.innerHTML;
        }
      }
    } catch (err) {
      log(err);
    }
  };

  const scheduleSync = () => {
    window.clearTimeout(debounceId);
    debounceId = window.setTimeout(() => {
      const v = getVariantId();
      syncPrice(v);
    }, 120);
  };

  // 1) Watch URL changes (your theme updates ?variant=... without reload)
  const _pushState = history.pushState;
  const _replaceState = history.replaceState;

  history.pushState = function () {
    _pushState.apply(this, arguments);
    scheduleSync();
  };
  history.replaceState = function () {
    _replaceState.apply(this, arguments);
    scheduleSync();
  };
  window.addEventListener("popstate", scheduleSync);

  // 2) Watch common variant inputs directly (radio/select)
  productRoot.addEventListener("change", (e) => {
    const t = e.target;
    if (!t) return;
    // Most themes use these names/attributes
    if (
      (t.matches && t.matches('select[name^="options"], select[name="id"], input[name="id"], input[type="radio"][name^="options"]')) ||
      t.closest?.(".xo-product-info-content__variants")
    ) {
      scheduleSync();
    }
  });

  // 3) Initial sync (covers first paint if URL variant differs from default)
  scheduleSync();
})();
